import { render, staticRenderFns } from "./newDesc4.vue?vue&type=template&id=ef1c75a8&scoped=true"
import script from "./newDesc4.vue?vue&type=script&lang=js"
export * from "./newDesc4.vue?vue&type=script&lang=js"
import style0 from "./newDesc4.vue?vue&type=style&index=0&id=ef1c75a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c75a8",
  null
  
)

export default component.exports